<div class="heading">
  <img src="{{ deployUrl }}/assets/bancagenerali/LogoBG.jpg" />
</div>
<div class="main">
  <div class="content">
    <img src="{{ deployUrl }}/assets/bancagenerali/homepage.png" />
    <div class="loginButton-container"><a class="loginButton" (click)="onClickLogin()">LOGIN</a></div>
  </div>
</div>
